import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/Button';

import InputWrapper from '../input-wrapper';

/**
 * @param {object} props
 * @return {object}
 */
export const ButtonInput = (props) => (
    <InputWrapper id={props.id} label={props.label}>
        <div>
            <Button id={props.id} value={props.value} onClick={props.onClick}>
                {props.text}
            </Button>
        </div>
    </InputWrapper>
);

ButtonInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func,
};
